// http://localhost:1002/pg/jagdeepxyza
import React, { useEffect, useState } from 'react';
import { useParams } from "react-router-dom";
import { Container, Row, Col, Image, Table } from 'react-bootstrap';
import * as Common from '../Common';

let imgLogo = {
    height: '100px'
}

let pError = {
    color: 'red',
    fontFamily: 'Courier New',
    fontSize: '30px'
}

function Cashfreereturn() {
    const { orderid, ordertoken } = useParams();

    const [onceRun, setOnceRun] = useState(false);
    const [trnDetail, setTrnDetail] = useState([]);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            var object1 = {
                orderid: orderid,
                ordertoken: ordertoken
            }
            // http://localhost:1002/cf/20220527025201/2jkjkjkkiiiiiiiiiiiiiiiiiiiiiiiii
            Common.callApi(Common.apiCashFree, [1, 'paymentverify', JSON.stringify(object1)], function (result) {
                let resp = JSON.parse(result);
                setTrnDetail(resp[0]);
            });
            setOnceRun(true);
        }
    }, [onceRun]);

    // {"message":"Order Reference Id does not exist","code":"order_id_not_found","type":"invalid_request_error"}
    /*
        [{"auth_id":null,"authorization":null,"bank_reference":"2792","cf_payment_id":885245745
        ,"entity":"payment","is_captured":true,"order_amount":7005.94,"order_id":"20220527025201"
        ,"payment_amount":7005.94,"payment_completion_time":"2022-05-27T15:25:34+05:30"
        ,"payment_currency":"INR","payment_group":"net_banking","payment_message":"Transaction pending"
        ,"payment_method":{"netbanking":{"channel":"link"
        ,"netbanking_bank_code":3022,"netbanking_bank_name":"ICICI Bank","netbanking_ifsc":"","netbanking_account_number":""}}
        ,"payment_status":"SUCCESS","payment_time":"2022-05-27T15:24:38+05:30"}]

    */
    return (
        <>
            <Container>
                <Row className='justify-content-center'>
                    <div className='col-md-6'>

                        <Row>
                            <Col>&nbsp;</Col>
                        </Row>
                        <Table>
                            <tbody>
                                <tr>
                                    <td colSpan={2} style={{ 'text-align': 'center' }}>
                                        <Image style={imgLogo} src="../../img/zenith-e-remit.png" fluid />
                                    </td>
                                </tr>
                                {
                                    typeof (trnDetail.payment_status) !== 'undefined' ?
                                        <>
                                            <tr>
                                                <td>Order Id  : </td><td>{trnDetail.order_id}</td>
                                            </tr>
                                            <tr>
                                                <td>Amount  : </td><td>{trnDetail.payment_amount}</td>
                                            </tr>
                                            <tr>
                                                <td>Time  : </td><td>{trnDetail.payment_completion_time}</td>
                                            </tr>
                                            <tr>
                                                <td>Time  : </td><td>{trnDetail.payment_status}</td>
                                            </tr>
                                            <tr>
                                                <td>Currency  : </td><td>{trnDetail.payment_currency}</td>
                                            </tr>
                                            <tr>
                                                <td>Bank Reference  : </td><td>{trnDetail.bank_reference}</td>
                                            </tr>
                                            <tr>
                                                <td>Payment Id  : </td><td>{trnDetail.cf_payment_id}</td>
                                            </tr>
                                        </>
                                        : <>
                                            &nbsp;
                                        </>
                                }
                            </tbody>
                        </Table>
                    </div>
                </Row>

            </Container>
        </>
    )
}
export default Cashfreereturn;